import { Component } from '@angular/core';

@Component({
    selector: 'app-confirm-no-registrations-dialog',
    templateUrl: './confirm-no-registrations-dialog.component.html',
    styleUrls: ['./confirm-no-registrations-dialog.component.scss'],
    standalone: false
})
export class ConfirmNoRegistrationsDialogComponent {
  constructor() {}
}
